import callApiAxiosClient from "../../axios/axios_client";


function deleteUser(ids: string[]): Promise<void> {
    const token = JSON.parse(localStorage.getItem('user')!)
    const authorization = 'Bearer ' + token.token
    return callApiAxiosClient<void>({
        method: "delete",
        url: "usersactions/users",
        headers: {
            "Content-Type": "Application/json",
            "Authorization": authorization
        },
        data: {
           ids:ids
        }
    })
}
export default deleteUser;